import { render, staticRenderFns } from "./GridRelator.vue?vue&type=template&id=fa1afaf8&"
import script from "./GridRelator.vue?vue&type=script&lang=js&"
export * from "./GridRelator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports